__turbopack_context__.v({
  "article": "article-module-scss-module__-MbpUa__article",
  "articleDetails": "article-module-scss-module__-MbpUa__articleDetails",
  "articleDetailsContent": "article-module-scss-module__-MbpUa__articleDetailsContent",
  "articleDetailsSummary": "article-module-scss-module__-MbpUa__articleDetailsSummary",
  "articleLayout": "article-module-scss-module__-MbpUa__articleLayout",
  "articleScrollArea": "article-module-scss-module__-MbpUa__articleScrollArea",
  "articleWithToc": "article-module-scss-module__-MbpUa__articleWithToc",
  "authorAbout": "article-module-scss-module__-MbpUa__authorAbout",
  "authorImageContainer": "article-module-scss-module__-MbpUa__authorImageContainer",
  "authorSection": "article-module-scss-module__-MbpUa__authorSection",
  "authorTextContainer": "article-module-scss-module__-MbpUa__authorTextContainer",
  "bigDesktopPageWidth": "article-module-scss-module__-MbpUa__bigDesktopPageWidth",
  "body": "article-module-scss-module__-MbpUa__body",
  "breadcrumbMargin": "article-module-scss-module__-MbpUa__breadcrumbMargin",
  "ctaContainer": "article-module-scss-module__-MbpUa__ctaContainer",
  "ctaContainerWithoutDescription": "article-module-scss-module__-MbpUa__ctaContainerWithoutDescription",
  "desktopPageWidth": "article-module-scss-module__-MbpUa__desktopPageWidth",
  "disclosure": "article-module-scss-module__-MbpUa__disclosure",
  "disclosureButton": "article-module-scss-module__-MbpUa__disclosureButton",
  "disclosureIcon": "article-module-scss-module__-MbpUa__disclosureIcon",
  "disclosurePanel": "article-module-scss-module__-MbpUa__disclosurePanel",
  "disclosurePanelInner": "article-module-scss-module__-MbpUa__disclosurePanelInner",
  "disclosurePanelOpen": "article-module-scss-module__-MbpUa__disclosurePanelOpen",
  "disclosureSummaryContent": "article-module-scss-module__-MbpUa__disclosureSummaryContent",
  "factCheck": "article-module-scss-module__-MbpUa__factCheck",
  "factCheckText": "article-module-scss-module__-MbpUa__factCheckText",
  "faqsSection": "article-module-scss-module__-MbpUa__faqsSection",
  "headerImageContainer": "article-module-scss-module__-MbpUa__headerImageContainer",
  "hideWhenMobile": "article-module-scss-module__-MbpUa__hideWhenMobile",
  "imageContainer": "article-module-scss-module__-MbpUa__imageContainer",
  "imageContainerPortrait": "article-module-scss-module__-MbpUa__imageContainerPortrait",
  "learnMore": "article-module-scss-module__-MbpUa__learnMore",
  "learnMoreButtons": "article-module-scss-module__-MbpUa__learnMoreButtons",
  "learnMoreContent": "article-module-scss-module__-MbpUa__learnMoreContent",
  "learnMoreImageContainer": "article-module-scss-module__-MbpUa__learnMoreImageContainer",
  "learnMoreTextContainer": "article-module-scss-module__-MbpUa__learnMoreTextContainer",
  "metaInformation": "article-module-scss-module__-MbpUa__metaInformation",
  "mobileToc": "article-module-scss-module__-MbpUa__mobileToc",
  "root": "article-module-scss-module__-MbpUa__root",
  "rotated": "article-module-scss-module__-MbpUa__rotated",
  "sanitized": "article-module-scss-module__-MbpUa__sanitized",
  "showWhenMobile": "article-module-scss-module__-MbpUa__showWhenMobile",
  "spacerRight": "article-module-scss-module__-MbpUa__spacerRight",
  "threeLineEllipse": "article-module-scss-module__-MbpUa__threeLineEllipse",
  "tocContainer": "article-module-scss-module__-MbpUa__tocContainer",
  "tocHeading": "article-module-scss-module__-MbpUa__tocHeading",
  "tocItemActive": "article-module-scss-module__-MbpUa__tocItemActive",
  "tocList": "article-module-scss-module__-MbpUa__tocList",
  "tocSidebar": "article-module-scss-module__-MbpUa__tocSidebar",
  "tocSidebarContent": "article-module-scss-module__-MbpUa__tocSidebarContent",
  "tocSidebarInner": "article-module-scss-module__-MbpUa__tocSidebarInner",
  "tocSummary": "article-module-scss-module__-MbpUa__tocSummary",
});
